import React, { useEffect, useState } from 'react'

// Xem trước PDF bằng pdfjs (render ra ảnh) — KHÔNG phụ thuộc trình duyệt mở PDF hay header
// Content-Disposition của server (iframe/embed có thể bị ép tải → trắng). Dùng chung GV & HS.
const PdfPreview: React.FC<{ url: string; maxPages?: number; className?: string }> = ({ url, maxPages = 8, className }) => {
  const [pages, setPages] = useState<string[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)
  const [err, setErr] = useState('')

  useEffect(() => {
    let alive = true
    ;(async () => {
      setLoading(true); setErr(''); setPages([])
      try {
        const pdfjsLib: any = await import('pdfjs-dist')
        pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`
        const pdf = await pdfjsLib.getDocument({ url }).promise
        if (!alive) return
        setTotal(pdf.numPages)
        const n = Math.min(pdf.numPages, maxPages)
        const out: string[] = []
        for (let p = 1; p <= n; p++) {
          const pg = await pdf.getPage(p)
          const v1 = pg.getViewport({ scale: 1 })
          const scale = Math.min(1200 / v1.width, 2)
          const vp = pg.getViewport({ scale })
          const cv = document.createElement('canvas')
          cv.width = Math.round(vp.width); cv.height = Math.round(vp.height)
          await pg.render({ canvasContext: cv.getContext('2d')!, viewport: vp }).promise
          if (!alive) return
          out.push(cv.toDataURL('image/jpeg', 0.85))
        }
        if (alive) setPages(out)
      } catch {
        if (alive) setErr('Không hiển thị được bản xem trước. Hãy bấm "Tải xuống" để mở file.')
      } finally { if (alive) setLoading(false) }
    })()
    return () => { alive = false }
  }, [url, maxPages])

  if (loading) return <div className="text-sm text-gray-400 py-4 text-center">Đang tải xem trước…</div>
  if (err) return <div className="text-sm text-amber-700 py-2">{err}</div>
  return (
    <div className={className}>
      {pages.map((src, i) => (
        <img key={i} src={src} alt={`Trang ${i + 1}`} className="w-full rounded border border-gray-200 mb-2 bg-white" />
      ))}
      {total > pages.length && (
        <p className="text-[11px] text-gray-400">Mới xem {pages.length}/{total} trang — bấm "Tải xuống" để xem đủ.</p>
      )}
    </div>
  )
}

export default PdfPreview
